import { useEffect,useState } from "react";

import { Pagination,Table } from "antd";
import { formatDateHandler2 } from "utils/common";
import { defaultPagination,handlePageChange,itemRender,pageSizeOptions } from "utils/table";

import { SkeltonLoader } from "components/skeltonLoader";

import { Button } from "components/Button";

import { getAllDocumentApi,getAllDocumentTypeApi } from "api/services/documents";
import { useSearchParams } from 'react-router-dom';

import { format } from "date-fns";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";





const AllDocuments = ({userData}) => {

    const [searchParams, setSearchParams] = useSearchParams();
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

    const navigate = useNavigate()

  
  const [loading, setLoading] = useState(false);
  const [selectedPage, setSelectedPage] = useState(0);
												   
  const [documentModal, setDocumentModal] = useState(false);
  const [ selectedDocument, setSelectedDocument] = useState(false);
  const [documentData, setDocumentData] = useState([]);
  const [view, setView] = useState(isMobile? "grid":"list");
  const [storeType, setStoreType] = useState("user");

  const [showFilterDrawer, setShowFilterDrawer] = useState(false)
  const [documentType, setDocumentType] = useState([])
  const [documentTypeLoading, setDocumentTypeLoading] = useState(false)

  const [pageSettings , setPageSettings] = useState({
    ...defaultPagination,
    page: searchParams.get("page") || 1,
    pageSize: searchParams.get("size") || 50,
    sortType: searchParams.get("sort_type") || "",
    sortBy: searchParams.get("sort_byb") || "",
    document_type: searchParams.get("document_type") ,
    // document_sub_type: searchParams.get("document_sub_type") ,
    user: searchParams.get("company_user")

    //document_type=user&document_sub_type=passport&user=1&issue_date_after=2025-10-28&issue_date_before=2025-10-29&expiry_date_after=2025-10-30&expiry_date_before=2025-10-30&sort_type=ascend&sort_by=issue_date&expiry_in=365
})


// const getFilterParams = useCallback(()=>{
//   let filter_params = filterHandler(filters)
//     return filter_params
        
// })

const setDocumentParams = (pageData) => {
    // let filter_params = getFilterParams()
    let params = {
        size: pageData?.pageSize,
        page: pageData?.page,
        sort_by: pageData?.sortBy || "",
        sort_type: pageData?.sortType || "",
        // ...filter_params
    }
    setSearchParams(params)
}



    const getDocumentList = () => {
        setLoading(true)
        // setFilterLoading(true)      
        // let filter_params = getFilterParams()
        let filter_params = {}
          if(filter_params?.issue_date_after){
            filter_params.issue_date_after = format(new Date(filter_params.issue_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.issue_date_before){
          filter_params.issue_date_before = format(new Date(filter_params.issue_date_before), "yyyy-MM-dd")
         }

        if(filter_params?.expiry_date_after){
            filter_params.expiry_date_after = format(new Date(filter_params.expiry_date_after), "yyyy-MM-dd")
        }
        if(filter_params?.expiry_date_before){
            filter_params.expiry_date_before = format(new Date(filter_params.expiry_date_before), "yyyy-MM-dd")
        }


        console.log(userData, "&&&&&&&&&&&&&&&")
          
        getAllDocumentApi({         
        company_user: userData?.id,
          sort_by:pageSettings?.sortBy,
          sort_type: pageSettings?.sortType,
          page_size: pageSettings?.pageSize,
          page: pageSettings?.page,
          document_type: pageSettings?.document_type,
          document_sub_type: pageSettings?.document_sub_type,
          document_type__type: storeType,
          ...filter_params    
        }).then(response=>{
          if(view=="grid" && pageSettings?.page!==1){
            setDocumentData([...documentData,...response.data.results]);

          }else{
            setDocumentData(response.data.results);

          }

          
          setPageSettings({
            ...pageSettings,
            total: response.data.count
          })
    
          setLoading(false)
        //   setFilterLoading(false)
          setShowFilterDrawer(false)
        }).catch(e=>{
          setLoading(false)
        })
    }
  useEffect(()=>{
    if(userData?.id){
      getDocumentList()
    }

  },[pageSettings?.page, pageSettings?.pageSize, pageSettings?.sortBy, pageSettings?.sortType, pageSettings?.filters, storeType, userData])

  useEffect(()=>{
    // setDocumentParams(pageSettings)
  },[pageSettings])

  useEffect(()=>{
    setDocumentTypeLoading(true)
    getAllDocumentTypeApi({type:storeType}).then(response=>{
      setDocumentType(response.data.results)
      setDocumentTypeLoading(false)
    }).catch(e=>{
      setDocumentTypeLoading(false)
    })
  },[storeType])

//   const handleApplyFilter = () => {
//     setPageSettings({
//         ...pageSettings,
//         page: 1,
//         // filters
//       })

//   }


  const handleGridChange = (page, size) =>{
    setPageSettings({
      ...pageSettings,
      pageSize: size,
      page,
    })				 
			 
	
  }


  const handleChange = (pagination, filters, sorter) => {
    let pageData = handlePageChange(pagination, filters, sorter, pageSettings)
    console.log(pageData)
    setPageSettings(pageData)
  }; 
							
		
  




  const handleDocumentDetailPage = (id, index) => {			  
    navigate(`/documents/${id}?company_user=${userData?.id}&type=user`)
    setSelectedPage(index)
  }


  const columns = [
    {
      title: "Document Name",
      dataIndex: "name",
      sorter: true,
      render: (text, record) => (
        <div className="profile-split d-flex flex-column">
          <span className="table-avatar">{record.name}</span>
         
        </div>
      ),
    },

    // {
    //   title: "Document No",
    //   dataIndex: "document_number",
    //   render: (text, record) => (
    //     <span className="table-avatar">{record.document_number}</span>
    //   ),
    // },

    {
      title: "Type",
      dataIndex: "document_sub_type",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span className="badge badge-soft-info">
            {record.document_type?.name}
          </span>
        </div>
      ),
    },

    {
 title: "Attachments",
      dataIndex: "document_sub_type",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
        <span className="small text-muted">
              {" "}
              <i class="fa-solid fa-paperclip" /> {record.attachments_count}{" "}
              Attachments{" "}
            </span>
        </div>
      ),
    },
    

    {
      title: "Issue Date",
      dataIndex: "issue_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.issue_date)}
        </span>
      ),
    },

    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.expiry_date)}
        </span>
      ),
    },
    {
      title: "Expires In",
      dataIndex: "expiry_notify_in_days",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <span className="table-avatar">{record.expiry_in_days} Days</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "is_expired",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span
            className={`badge badge-soft-${
              record.is_expired ? "danger" : "success"
            }`}
          >
            {record.is_expired ? "Expired" : "Active"}
          </span>
        </div>
      ),
    },
  ];
  useEffect(()=>{
    setStoreType("user")
  },[])
  const EmptyState = () => (
    <div className="col-12" style={{ 
      display: "flex", 
      flexDirection: "column", 
      alignItems: "center", 
      justifyContent: "center",
      padding: isMobile ? "60px 20px" : "80px 40px",
      textAlign: "center"
    }}>
      <div style={{
        width: isMobile ? "120px" : "150px",
        height: isMobile ? "120px" : "150px",
        marginBottom: "24px",
        opacity: 0.6
      }}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14 2H6C5.46957 2 4.96086 2.21071 4.58579 2.58579C4.21071 2.96086 4 3.46957 4 4V20C4 20.5304 4.21071 21.0391 4.58579 21.4142C4.96086 21.7893 5.46957 22 6 22H18C18.5304 22 19.0391 21.7893 19.4142 21.4142C19.7893 21.0391 20 20.5304 20 20V8L14 2Z" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M14 2V8H20" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 13H8" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M16 17H8" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <path d="M10 9H9H8" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      <h3 style={{ 
        fontSize: isMobile ? "18px" : "20px", 
        fontWeight: "600", 
        color: "#1f2937",
        marginBottom: "8px"
      }}>
        No Documents Found
      </h3>
      <p style={{ 
        fontSize: isMobile ? "14px" : "15px", 
        color: "#6b7280",
        margin: 0,
        maxWidth: "400px"
      }}>
        This employee doesn't have any documents yet.
      </p>
    </div>
  );

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else if (documentData.length === 0) {
      return <EmptyState />;
    } else {
      return (
        <>
          {documentData.map((document, index) => (
            <div
              className="col-md-6 col-sm-1 col-12 col-lg-3 col-xl-4"
              key={document.id}
              style={isMobile ? { paddingLeft: "4px", paddingRight: "4px", marginBottom: "12px" } : {}}
            >
              <div className="card shadow-sm" style={{ 
                borderRadius: "8px", 
                border: "none",
                background: "linear-gradient(135deg, #ffffff 0%, #fef2f2 100%)",
                margin: isMobile ? 0 : "0 0 20px 0",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer"
              }}
              onClick={() => handleDocumentDetailPage(document.id, index)}
              >
                <div style={{
                  position: "absolute",
                  top: "12px",
                  right: "12px",
                  zIndex: 10
                }}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleDocumentDetailPage(document.id, index);
                      }}
                    style={{
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      background: "linear-gradient(135deg, rgb(211, 0, 26) 0%, #f43b48 50%, #fc133d 100%)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#ffffff",
                      textDecoration: "none",
                      boxShadow: "0 2px 8px rgba(211, 0, 26, 0.2)",
                      cursor: "pointer"
                    }}
                    >
                    <i className="fa fa-eye" style={{ fontSize: "14px" }}></i>
                  </a>
                </div>
                <div className="card-body" style={{ padding: isMobile ? "16px" : "20px" }}>
                  {/* Document Name - Main Highlight */}
                  <div style={{ marginBottom: "16px" }}>
                    <h4 style={{ 
                      fontSize: isMobile ? "16px" : "18px",
                      fontWeight: "600",
                      color: "#1f2937",
                      marginBottom: "8px",
                      lineHeight: "1.3"
                    }}>
                      {document?.name || "Untitled Document"}
                    </h4>
                    </div>

                  {/* Document Details */}
                  <div style={{
                    borderTop: "1px solid #e5e7eb",
                    paddingTop: "12px",
                    marginBottom: "12px"
                  }}>
                    <div className="row g-2">
                      {document?.issue_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            <i className="la la-calendar" style={{ marginRight: "4px" }}></i>
                            Issue Date
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(document.issue_date)}
                          </div>
                        </div>
                      )}
                      {document?.expiry_date && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            <i className="la la-calendar-check" style={{ marginRight: "4px" }}></i>
                            Expiry Date
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151", fontWeight: "500" }}>
                            {formatDateHandler2(document.expiry_date)}
                          </div>
                        </div>
                      )}
                      {document?.expiry_in_days !== undefined && (
                        <div className="col-6">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            <i className="la la-clock" style={{ marginRight: "4px" }}></i>
                            Expires In
                          </div>
                          <div style={{ fontSize: "12px", color: document?.is_expired ? "#ef4444" : "#374151", fontWeight: "600" }}>
                            {document.expiry_in_days} {document.expiry_in_days === 1 ? "day" : "days"}
                          </div>
                        </div>
                      )}
                      <div className="col-6">
                        <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                          Status
                        </div>
                        <div>
                          <span className={`badge badge-soft-${document?.is_expired ? "danger" : "success"}`} style={{
                            fontSize: "11px",
                            padding: "4px 8px",
                            borderRadius: "4px"
                          }}>
                            {document?.is_expired ? "Expired" : "Active"}
                          </span>
                        </div>
                      </div>
                      {document?.attachments_count !== undefined && (
                        <div className="col-12">
                          <div style={{ fontSize: "11px", color: "#9ca3af", marginBottom: "4px", fontWeight: "500" }}>
                            <i className="fa-solid fa-paperclip" style={{ marginRight: "4px" }}></i>
                            Attachments
                          </div>
                          <div style={{ fontSize: "12px", color: "#374151" }}>
                            {document.attachments_count} {document.attachments_count === 1 ? "attachment" : "attachments"}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

 

  return (
    <>
          {view == "grid" ? (
        <div className="row" style={isMobile ? { marginLeft: "8px", marginRight: "8px" } : {}}>
              {!loading && documentData.length === 0 ? (
                <EmptyState />
              ) : (
                <GridView />
              )}
              {documentData.length > 0 && (
                <div className="my-2 d-flex justify-content-end ">
                  <div className="col-sm-12 col-md-6 ">
                    <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className="row">
          <div className="col-12">
            {!loading && documentData.length === 0 ? (
              <div className="card shadow-sm" style={{ borderRadius: "12px", border: "1px solid #e0e0e0", overflow: "hidden" }}>
                <EmptyState />
              </div>
            ) : (
              <div className="card shadow-sm" style={{ borderRadius: "8px", border: "1px solid #e5e7eb", overflow: "hidden", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                <style>{`
                  .modern-table .ant-table-tbody > tr {
                    background-color: #ffffff !important;
                  }
                  .modern-table .ant-table-tbody > tr:hover > td {
                    background-color: #f5f5f5 !important;
                  }
                  .modern-table .ant-table-thead > tr > th {
                    background-color: #f8f9fa !important;
                    font-weight: 600;
                    color: #333;
                    border-bottom: 2px solid #e0e0e0;
                    padding: 10px 12px;
                    font-size: 13px;
                  }
                  .modern-table .ant-table-tbody > tr > td {
                    border-bottom: 1px solid #f0f0f0;
                    padding: 10px 12px;
                    font-size: 13px;
                  }
                  .modern-table .ant-table-wrapper .ant-table-pagination.ant-pagination {
                    border-top: 1px solid #f0f0f0;
                    background-color: #ffffff;
                    border-bottom-left-radius: 12px;
                    border-bottom-right-radius: 12px;
                  }
                  .modern-table .ant-table {
                    border: none !important;
                  }
                  .modern-table .ant-table-container {
                    border: none !important;
                  }
                `}</style>
                <div className="table-responsive" style={{ overflowX: "auto" }}>
                  <Table
                    className="mb-0 modern-table"
                    style={{
                      borderRadius: "12px",
                      minWidth: "100%"
                    }}
                    scroll={{ x: "max-content" }}
                    columns={columns}
                    dataSource={documentData}
                    rowKey={(record) => record.id}
                    loading={loading}
                    rowClassName="clickable-row"
                    onRow={(record, index) => ({
                      onClick: (e) => {
                        if (e.target.closest('a, button')) return;
                        handleDocumentDetailPage(record.id, index);
                      },
                    })}
                    pagination={{
                      total: pageSettings?.total,
                      pageSize: pageSettings?.pageSize,
                      showSizeChanger: true,
                      pageSizeOptions: pageSizeOptions,
                      itemRender: itemRender,
                      position: "right",
                      current: pageSettings?.page,
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${total} items`,
                      style: { padding: "16px" }
                    }}
                    onChange={handleChange}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default AllDocuments;
